/**
 * 一番賞商品熱度：開抽請求真的送出時打一次 POST /lottery/heat（+1）。
 *
 * 旁路統計，不參與抽獎與付款流程：recordHeat 不回傳結果，任何失敗一律吞掉，
 * 回傳的 Promise 永不 reject，呼叫端不必等也不必 catch。
 */

/**
 * 熱度 +1。旁路統計：不回傳結果，任何失敗（含同步拋錯）一律吞掉，永不 reject。
 *
 * @param {{ post: (route: string, params: object) => Promise<unknown> }} client rest-client 實例
 * @param {number} productId
 * @returns {Promise<undefined>}
 */
export function recordHeat(client, productId) {
    return Promise.resolve()
        .then(() => client.post('/lottery/heat', { product_id: productId }))
        .then(
            () => undefined,
            () => undefined
        );
}
